import { render, staticRenderFns } from "./plantilla.vue?vue&type=template&id=2f5bb728&scoped=true"
import script from "./plantilla.vue?vue&type=script&lang=js"
export * from "./plantilla.vue?vue&type=script&lang=js"
import style0 from "./plantilla.vue?vue&type=style&index=0&id=2f5bb728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5bb728",
  null
  
)

export default component.exports